var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColorLinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.348 27h3.484V13.819H9.348V27zM11.09 8C9.93 8 9 8.95 9 10.137c0 1.188.929 2.138 2.09 2.138 1.162 0 2.09-.95 2.09-2.138C13.18 8.95 12.253 8 11.09 8zm7.665 7.838v-2.02H15.27V27h3.484v-6.769c0-3.8 4.761-4.037 4.761 0V27H27v-8.075c0-6.413-6.62-6.175-8.245-3.088z",
    fill: "#2E5ECC"
  })));
}

export default SvgColorLinked;